<script lang="ts">
  // libs
  import { convertToDistributorDate } from "@shared/svelte/Components/DateFormatter/LocaleString.svelte";

  // components
  import FormatMoney from "@shared/svelte/Components/FormatMoney.svelte";
  import TransferBreakdown from "@distributor/svelte/Payments/TransferBreakdown.svelte";
  import RetailerDisplayName from "@distributor/svelte/Payments/RetailerDisplayName.svelte";

  // types
  import type { PaymentTransferType } from "@shared/types/Invoice";

  // props
  export let payment: PaymentTransferType;

  // data
  let paymentStatusClass = {
    pending: "fizz-pill-yellow",
    settled: "fizz-pill-green",
    failed: "fizz-pill-red",
    canceled: "fizz-pill-red",
  };
</script>

<div class="fizz-hide-on-large fizz-border-bottom">
  <details class="fizz-accordion">
    <summary>
      <div class="fizz-space-between">
        <span class="fizz-heading-4">
          {#key payment.id}
            <RetailerDisplayName {payment} />
          {/key}
        </span>
        <span class={"fizz-hide-on-open " + paymentStatusClass[payment.settlement_status]}>
          {payment.settlement_status.charAt(0).toUpperCase() + payment.settlement_status.slice(1)}
        </span>
      </div>
      <p class="fizz-text-subdued fizz-text-small fizz-hide-on-open">
        {payment.payment_invoice.invoice_reference_id}
        <br />
        {#if payment.settlement_status === "settled"}
          <FormatMoney input={payment.net_amount} formatType={"5"} />
        {:else}
          Pending
        {/if}
      </p>
    </summary>
    <div class="fizz-inset-square-16">
      <dl class="fizz-definition-list-horizontal fizz-stack-16">
        <dt>Account:</dt>
        <dd>{payment.retailer?.name || "N/A"}</dd>
        <dt>Transaction Date</dt>
        <dd>{convertToDistributorDate(payment.created_at)}</dd>
        <dt>Status</dt>
        <dd>
          <span class={paymentStatusClass[payment.settlement_status]}>
            {payment.settlement_status.charAt(0).toUpperCase() + payment.settlement_status.slice(1)}
          </span>
        </dd>
        <dt>Settlement Date</dt>
        <dd>
          {#if payment.date_settled}
            {convertToDistributorDate(payment.date_settled)}
          {/if}
        </dd>
        <dt>Invoice</dt>
        <dd>{payment.payment_invoice.invoice_reference_id}</dd>
        <dt>Payment Confirmation Code</dt>
        {#if payment.payment_confirmation}
          <dd>
            {payment.payment_confirmation.confirmation_code}
          </dd>
        {:else}
          <dd />
        {/if}
        <dt>Net Amount</dt>
        <dd>
          {#if payment.settlement_status === "settled"}
            <FormatMoney input={payment.net_amount} formatType={"5"} />
          {:else if payment.settlement_status === "failed"}
            <FormatMoney input={-1 * payment.net_amount} formatType={"5"} />
          {:else}
            Pending
          {/if}
        </dd>
      </dl>
      <dl class="fizz-flow-16 fizz-surface-gray fizz-inset-stretch-24">
        <TransferBreakdown {payment} />
      </dl>
    </div>
  </details>
</div>
